var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { styled } from 'goober';
import { forwardRef, useRef, useState } from 'react';
import { Loading } from '../styled/Basic';
var SIZE_DEFAULTS = {
    small: {
        height: '24px',
        minWidth: '24px',
        lineHeight: '14px',
        fontSize: '9px',
    },
    large: {
        height: '32px',
        minWidth: '32px',
        lineHeight: '15px',
        fontSize: '12px',
        fontWeight: '600',
    },
};
var ToggleContainer = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $content = _a.$content, _b = _a.$checked, $checked = _b === void 0 ? false : _b, _c = _a.$disabled, $disabled = _c === void 0 ? false : _c, _d = _a.$focused, $focused = _d === void 0 ? false : _d, _e = _a.$size, $size = _e === void 0 ? 'large' : _e, _f = _a.$color, $color = _f === void 0 ? 'primary' : _f;
    var style = $checked
        ? {
            color: $color === 'neutral' ? theme.colors.ui.dark : theme.colors[$color].w500,
            backgroundColor: $disabled ? theme.colors.neutral.w700 : theme.colors[$color].w50,
            borderColor: $disabled ? theme.colors.neutral.w700 : theme.colors[$color].w500,
            '&:hover': $disabled
                ? undefined
                : {
                    color: $color === 'neutral' ? theme.colors.ui.dark : theme.colors[$color].w700,
                    borderColor: theme.colors[$color].w700,
                },
            '&:active': $disabled
                ? undefined
                : {
                    color: $color === 'neutral' ? theme.colors.ui.dark : theme.colors[$color].w700,
                    borderColor: theme.colors[$color].w900,
                },
        }
        : {
            color: $color === 'neutral' ? theme.colors.ui.dark : theme.colors.neutral.w900,
            backgroundColor: $disabled ? theme.colors.neutral.w700 : theme.colors.neutral.w50,
            borderColor: $disabled ? theme.colors.neutral.w700 : theme.colors.neutral.w100,
            '&:hover': $disabled
                ? undefined
                : {
                    backgroundColor: theme.colors.neutral.w100,
                    borderColor: theme.colors.neutral.w200,
                },
            '&:active': $disabled
                ? undefined
                : {
                    backgroundColor: theme.colors.neutral.w200,
                    borderColor: theme.colors.neutral.w300,
                },
        };
    return __assign(__assign({ boxSizing: 'border-box', textAlign: 'center', position: 'relative', display: 'flex', borderRadius: '4px', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', userSelect: 'none', appearance: 'none', padding: $content === 'icon' ? '0px' : '0px 10px', cursor: $disabled ? 'not-allowed' : 'pointer', outlineStyle: $focused && !$disabled ? 'solid' : 'none', outlineColor: theme.colors.ui.dark, outlineWidth: '1px', borderStyle: 'solid', borderWidth: '2px', '&:disabled, &:disabled > .fs-button_spinner': {
            cursor: 'not-allowed',
        }, 'span > .fs-icon_svg': {
            marginRight: $content === 'icon' ? ($size === 'small' ? '-4px' : '-8px') : undefined,
            marginLeft: $content === 'icon' ? ($size === 'small' ? '-4px' : '-8px') : undefined,
        } }, SIZE_DEFAULTS[$size]), style);
});
var ToggleInput = styled('input', forwardRef)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: 0;\n    clip: rect(0 0 0 0);\n    overflow: hidden;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    bottom: 0px;\n    right: 0px;\n"], ["\n    border: 0;\n    clip: rect(0 0 0 0);\n    overflow: hidden;\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    bottom: 0px;\n    right: 0px;\n"])));
function FSToggle(props, ref) {
    var _a;
    var _b = __read(useState(false), 2), focus = _b[0], setFocus = _b[1];
    var inputRef = useRef();
    var containerRef = useRef(null);
    var title = props.title, _c = props.checked, checked = _c === void 0 ? false : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, _e = props.$color, $color = _e === void 0 ? 'primary' : _e, _f = props.$size, $size = _f === void 0 ? 'large' : _f, _g = props.style, style = _g === void 0 ? {} : _g, className = props.className, onBlur = props.onBlur, onFocus = props.onFocus, icon = props.icon, _h = props.loading, loading = _h === void 0 ? false : _h, rest = __rest(props, ["title", "checked", "disabled", "$color", "$size", "style", "className", "onBlur", "onFocus", "icon", "loading"]);
    function handleClick(event) {
        if (disabled) {
            return;
        }
        if (event.target !== inputRef.current && inputRef.current) {
            event.preventDefault();
            inputRef.current.click();
            return;
        }
    }
    function handleMouseDown(event) {
        if (disabled) {
            return;
        }
        if (event.target !== inputRef.current && inputRef.current) {
            event.preventDefault();
            inputRef.current.focus({ preventScroll: true });
            return;
        }
    }
    function handleBlur(event) {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        setFocus(false);
    }
    function handleFocus(event) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        setFocus(true);
    }
    function initRefs(instance) {
        inputRef.current = instance;
        if (typeof ref === 'function') {
            ref(instance);
        }
        if (typeof ref === 'object' && ref !== null) {
            ref.current = instance;
        }
    }
    var Icon = icon;
    var content = !!Icon ? 'icon' : 'title';
    return (React.createElement(ToggleContainer, { ref: containerRef, style: loading ? __assign(__assign({}, style), { width: (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth }) : style, className: className, "$color": $color, "$content": content, "$size": $size, "$checked": checked, "$focused": focus, onMouseDown: handleMouseDown, onClick: handleClick },
        loading ? (React.createElement("span", { className: "fs-button_spinner", style: {
                display: 'grid',
                placeItems: 'center',
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
            } },
            React.createElement(Loading, null))) : (React.createElement(React.Fragment, null,
            typeof Icon === 'function' ? (React.createElement(Icon, { cursor: "inherit", height: $size === 'small' ? 24 : 32, width: $size === 'small' ? 24 : 32 })) : (Icon), title !== null && title !== void 0 ? title : null)),
        React.createElement(ToggleInput, __assign({}, rest, { ref: initRefs, type: "checkbox", checked: checked, disabled: disabled, onFocus: handleFocus, onBlur: handleBlur }))));
}
export default forwardRef(FSToggle);
var templateObject_1;
